import { useCallback, useState } from 'react'

import { Card } from "@aidron/aidron-ds";

import { generateSubtitlePeriod } from "../../../../../components/SharedComponents/ListItem/ListItem";

import { ModalTemplate, PredictionChart, ProductAnalysisChart } from "../../../../../components/SharedComponents/sharedComponents.index";
import { LOCATION_VALUES_FOR_PREDICTION_CHART } from "../../../../../components/components.constants";
import { SYSTEM_COLORS } from "../../../../../components/system.colors";

import { textFormatter } from "../../../../../utils/formatter/formatter";

const currencyFormatter = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const renderCardMetrics = ({ ctx, uiState }) => {

  const { 
    startDate, 
    endDate, 
    mode, 
    opportunityType,
    onSelectDetail,
    selectedDetail,
    bests,
    quality,
    levelPrice
  } = ctx || {};

  const { isTrendDetailPending } = uiState || {};

  const { behaviorChangeLevelMainText } = bests?.[0] || {};
  const { qualityIndicatorMainText } = quality?.[0] || {};

  const cardMetricsInformation = [
    {
      key: "behaviorChange",
      title: "Mudança de comportamento do subgrupo",
      text: behaviorChangeLevelMainText
    },
    // comentar o preço do subgrupo em produção
    // {
    //   key: "levelChange",
    //   title: "Preço do subgrupo",
    //   text: levelPrice?.levelPriceMainText
    // },
    {
      key: "quality",
      title: "Indicadores de qualidade",
      text: qualityIndicatorMainText
    },    
  ]  

  if(opportunityType === "trend") {
    return (
      <>
        <div style={{ borderBottom: `1px solid ${SYSTEM_COLORS.GRAY.COOL_LIGHT_GRAY}` }}>
          <header style={{ 
            display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
            <span style={{ width: 3, height: 14, borderRadius: 2, background: SYSTEM_COLORS.RED.BRICK_RED }} />
            <p style={{ fontSize: "0.813rem", fontWeight: 800, color: SYSTEM_COLORS.BLACK.EERIE_BLACK, letterSpacing: 0.4 }}>
              RECOMENDAÇÃO DE AÇÃO
            </p>
          </header>
        </div>

        {isTrendDetailPending ? (
          <p style={{ fontSize: 12.5, color: SYSTEM_COLORS.GRAY.MEDIUM_GRAY }}>
            Carregando recomendação...
          </p>
        ) : (
          cardMetricsInformation.map(({ key, title, text }) => {
            const isActive = key === selectedDetail;
            const isQuality = key === "quality";

            return (
              <div
                key={key}
                onClick={isQuality ? () => onSelectDetail?.(key) : undefined}
                style={{
                  display: "flex", alignItems: "flex-start", gap: 10,
                  background: isActive ? SYSTEM_COLORS.RED.BRICK_RED_8 : SYSTEM_COLORS.WHITE.WHITE,
                  border: isActive ? `1px solid ${SYSTEM_COLORS.RED.BRICK_RED}` : `1px solid ${SYSTEM_COLORS.GRAY.PLATINUM}`,
                  borderRadius: 12, padding: 14,
                  cursor: isQuality ? "pointer" : "default" }}>

                {/* ÍCONE */}
                <span style={{
                  width: 28, height: 28, borderRadius: "50%", background: SYSTEM_COLORS.RED.BRICK_RED_12,
                  display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <svg 
                    width={14} height={14} viewBox="0 0 24 24" fill="none" stroke={SYSTEM_COLORS.RED.BRICK_RED} 
                    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
                    <path d="M9 18h6" /><path d="M10 22h4" />
                  </svg>
                </span>

                {/* ÍCONE IA */}
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
                    <p style={{ fontSize: 13, fontWeight: 700, color: SYSTEM_COLORS.BLACK.EERIE_BLACK }}>
                      {title}
                    </p>

                    <span style={{
                      display: "inline-flex", alignItems: "center", gap: 4, whiteSpace: "nowrap",
                      padding: "3px 10px", borderRadius: 20, fontSize: "0.656rem", fontWeight: 700,
                      color: SYSTEM_COLORS.WHITE.WHITE, backgroundColor: SYSTEM_COLORS.RED.BRICK_RED }}>
                      <svg 
                        width={10} height={10} viewBox="0 0 24 24" fill="none" stroke={SYSTEM_COLORS.WHITE.WHITE}
                        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
                      </svg>
                      IA
                    </span>
                  </div>

                  <p style={{ fontSize: 12.5, color: SYSTEM_COLORS.GRAY.MEDIUM_GRAY, margin: isQuality ? "6px 0 0" : "6px 0 8px", lineHeight: 1.5 }}>
                    {text}
                  </p>

                  {!isQuality && (
                    <button
                      onClick={() => onSelectDetail?.(key)}
                      style={{
                        background: "none", border: "none", padding: 0, cursor: "pointer",
                        fontSize: 11, fontWeight: 700, color: SYSTEM_COLORS.RED.BRICK_RED, letterSpacing: 0.3,
                      }}>
                      VER DETALHE AO LADO
                    </button>
                  )}
                </div>
              </div>
            );
          })
        )}
      </>
    )
  }

  return (
    <>
      <div style={{ borderBottom: `1px solid ${SYSTEM_COLORS.GRAY.COOL_LIGHT_GRAY}` }}>
        <header style={{ 
          display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
          <span style={{ width: 3, height: 14, borderRadius: 2, background: SYSTEM_COLORS.RED.BRICK_RED }} />
          <p style={{ fontSize: "0.75rem", fontWeight: 700, color: SYSTEM_COLORS.BLACK.EERIE_BLACK, letterSpacing: 0.4 }}>
            RECOMENDAÇÃO DE AÇÃO
          </p>
        </header>
      </div>

      <div style={{
        display: "flex", alignItems: "flex-start", gap: 10,
        background: SYSTEM_COLORS.GREEN.FOREST_GREEN_8, border: `1px solid ${SYSTEM_COLORS.GREEN.FOREST_GREEN_2}`,
        borderRadius: 12, padding: 14 }}>

        <svg 
          width={16} height={16} viewBox="0 0 24 24" fill="none" stroke={SYSTEM_COLORS.GREEN.FOREST_GREEN} 
          strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
          <path d="M9 18h6" /><path d="M10 22h4" />
        </svg>
        <span style={{ fontSize: 13, fontWeight: 700, color: SYSTEM_COLORS.GREEN.FOREST_GREEN, lineHeight: 1.5 }}>
          {`Ajuste o plano entre os meses de ${generateSubtitlePeriod({ startDate, endDate, mode })} para o topo da demanda prevista.`}
        </span>
      </div>   
    </>
  )  
};

const getBehaviorAlertConfig = (status) => {
  switch (status) {
    case "alta":
      return {
        color: SYSTEM_COLORS.GREEN.FOREST_GREEN,
        background: SYSTEM_COLORS.GREEN.FOREST_GREEN_8,
        border: SYSTEM_COLORS.GREEN.FOREST_GREEN_2,
        visible: true
      };

    case "queda":
      return {
        color: SYSTEM_COLORS.RED.BRICK_RED,
        background: SYSTEM_COLORS.RED.BRICK_RED_8,
        border: SYSTEM_COLORS.RED.BRICK_RED_025,
        visible: true
      };

    case "estavel":
    case null:
    case undefined:
    default:
      return {
        visible: false
      };
  }
};

const BestsWeeklyTable = ({ ctx }) => {
  const { bestsList = [] } = ctx || {};

  if (!bestsList.length) return null;

  const latest = bestsList[0];

  const alertConfig = getBehaviorAlertConfig(
    latest?.behaviorChangeLevelAlertTextStatus
  );

  return (
    <>
      {alertConfig.visible && (
        <div
          style={{
            display: "flex", alignItems: "center", gap: 8,
            background: alertConfig.background,
            border: `1px solid ${alertConfig.border}`,
            borderRadius: 10, padding: "20px", marginBottom: 14 }}>
          <svg
            width={14} height={14} viewBox="0 0 24 24" fill="none"
            stroke={alertConfig.color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M16 17h6v-6" />
            <path d="m22 17-8.5-8.5-5 5L2 7" />
          </svg>

          <span style={{ fontSize: "0.781rem", fontWeight: 600, color: alertConfig.color }}>
            {latest?.behaviorChangeLevelAlertText}
          </span>
        </div>
      )}

      <div style={{ border: `1px solid ${SYSTEM_COLORS.GRAY.CULTURED}`, borderRadius: "10px", overflow: "hidden" }} >
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13, tableLayout: "fixed" }}>
          <colgroup>
            <col style={{ width: "10%" }} />
            <col style={{ width: "12%" }} />
            <col style={{ width: "10%" }} />
            <col style={{ width: "13%" }} />
            <col style={{ width: "55%" }} />
          </colgroup>

          <thead>
            <tr style={{ textAlign: "left", background: SYSTEM_COLORS.GRAY.CULTURED }}>
              <th style={{ 
                  padding: "10px 12px", fontSize: "0.656rem",
                  fontWeight: 700, color: SYSTEM_COLORS.GRAY.NEUTRAL_GRAY, letterSpacing: 0.4 }}>
                SEMANA
              </th>

              <th
                style={{
                  padding: "10px 12px", fontSize: "0.656rem", fontWeight: 700,
                  color: SYSTEM_COLORS.GRAY.NEUTRAL_GRAY, letterSpacing: 0.4 }}>
                PART. TOP 10
              </th>

              <th
                style={{
                  padding: "10px 12px", fontSize: "0.656rem", fontWeight: 700,
                  color: SYSTEM_COLORS.GRAY.NEUTRAL_GRAY, letterSpacing: 0.4 }}>
                Δ P.P.
              </th>

              <th
                style={{
                  padding: "10px 12px", fontSize: "0.656rem", fontWeight: 700,
                  color: SYSTEM_COLORS.GRAY.NEUTRAL_GRAY, letterSpacing: 0.4 }}>
                VENDA TOP 10
              </th>

              <th
                style={{
                  padding: "10px 12px", fontSize: "0.656rem", fontWeight: 700,
                  color: SYSTEM_COLORS.GRAY.NEUTRAL_GRAY, letterSpacing: 0.4 }}>
                BESTS DA SEMANA
              </th>
            </tr>
          </thead>

          <tbody>
            {bestsList.map((week, i) => {
              const isDown = Number(week.variationPercentPoint) < 0;

              return (
                <tr
                  key={week.week ?? i}
                  style={{ textAlign: "left", borderTop: `1px solid ${SYSTEM_COLORS.GRAY.PLATINUM}` }}>
                  <td style={{ padding: "12px", fontWeight: 700, color: SYSTEM_COLORS.BLACK.EERIE_BLACK }}>
                    {week.week}
                  </td>

                  <td style={{ padding: "12px", fontWeight: 700, color: SYSTEM_COLORS.BLACK.EERIE_BLACK }}>
                    {(week.participationTopTen * 100).toFixed(1)}%
                  </td>

                  <td
                    style={{
                      padding: "12px", fontWeight: 700,
                      color: isDown
                        ? SYSTEM_COLORS.RED.BRICK_RED
                        : SYSTEM_COLORS.GREEN.FOREST_GREEN }}>
                    {week.variationPercentPoint > 0 ? "+" : ""}
                    {week.variationPercentPoint}
                  </td>

                  <td style={{ padding: "12px", color: SYSTEM_COLORS.GRAY.DIM_GRAY }}>
                    {currencyFormatter.format(week.salesTopTen)}
                  </td>

                  <td style={{ padding: "10px", color: SYSTEM_COLORS.GRAY.DIM_GRAY }}>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "0.4rem" }}>
                      {[...new Set(
                        week.bestsOfWeek
                          .split("|")
                          .map(item => item.trim())
                          .filter(Boolean)
                      )].map((item, idx, arr) => (
                        <span key={idx}>
                          {textFormatter(item, { maxLength: 200 })}
                          {idx < arr.length - 1 ? "," : ""}
                        </span>
                      ))}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

const LevelPriceDetail = ({ ctx }) => {
  const { levelPrice } = ctx || {};

  if (!levelPrice) return null;

  const {
    avgPrice,
    estimatedElasticity,
    estimatedElasticityText,
    lastPriceChangeDate,
    lastPriceChangeWeeks,
    sensitivityToPrice,
    levelPriceAlertText
  } = levelPrice;

  const formattedLastChangeDate = new Date(lastPriceChangeDate).toLocaleDateString("pt-BR", {
    day: "2-digit", month: "2-digit", year: "2-digit",
  });

  return (
    <>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
        <hgroup style={{ border: `1px solid ${SYSTEM_COLORS.GRAY.PLATINUM}`, borderRadius: 12, padding: 14, background: SYSTEM_COLORS.WHITE.WHITE_SMOKE }}>
          <p style={{ fontSize: "0.6rem", fontWeight: 600, color: SYSTEM_COLORS.GRAY.SOFT_GRAY, letterSpacing: 0.4, margin: "0 0 6px" }}>
            SEMANAS SEM REMARCAR
          </p>
          <p style={{ fontSize: "1rem", fontWeight: 800, color: SYSTEM_COLORS.RED.BRICK_RED, margin: 0 }}>
            {lastPriceChangeWeeks} semanas
          </p>
        </hgroup>

        <hgroup style={{ border: `1px solid ${SYSTEM_COLORS.GRAY.PLATINUM}`, borderRadius: 12, padding: 14, background: SYSTEM_COLORS.WHITE.WHITE_SMOKE }}>
          <p style={{ fontSize: "0.6rem", fontWeight: 600, color: SYSTEM_COLORS.GRAY.SOFT_GRAY, letterSpacing: 0.4, margin: "0 0 6px" }}>
            ÚLTIMA REMARCAÇÃO
          </p>
          <p style={{ fontSize: "1rem", fontWeight: 800, color: SYSTEM_COLORS.BLACK.EERIE_BLACK, margin: 0 }}>
            {formattedLastChangeDate}
          </p>
        </hgroup>

        <hgroup style={{ border: `1px solid ${SYSTEM_COLORS.GRAY.PLATINUM}`, borderRadius: 12, padding: 14, background: SYSTEM_COLORS.WHITE.WHITE_SMOKE }}>
          <p style={{ fontSize: "0.6rem", fontWeight: 600, color: SYSTEM_COLORS.GRAY.SOFT_GRAY, letterSpacing: 0.4, margin: "0 0 6px" }}>
            PREÇO MÉDIO PRATICADO
          </p>
          <p style={{ fontSize: "1rem", fontWeight: 800, color: SYSTEM_COLORS.BLACK.EERIE_BLACK, margin: 0 }}>
            {currencyFormatter.format(avgPrice)}
          </p>
        </hgroup>

        <hgroup style={{ border: `1px solid ${SYSTEM_COLORS.GRAY.PLATINUM}`, borderRadius: 12, padding: 14, background: SYSTEM_COLORS.WHITE.WHITE_SMOKE }}>
          <p style={{ fontSize: "0.6rem", fontWeight: 600, color: SYSTEM_COLORS.GRAY.SOFT_GRAY, letterSpacing: 0.4, margin: "0 0 6px" }}>
            SENSIBILIDADE A PREÇO (IA)
          </p>
          <p style={{ fontSize: "1rem", fontWeight: 800, color: SYSTEM_COLORS.RED.BRICK_RED, margin: 0, textTransform: "capitalize" }}>
            {sensitivityToPrice}
          </p>
        </hgroup>
      </div>

      <hgroup style={{ border: `1px solid ${SYSTEM_COLORS.GRAY.PLATINUM}`, borderRadius: 12, padding: 14, background: SYSTEM_COLORS.WHITE.WHITE_SMOKE, marginBottom: 12 }}>
        <p style={{ fontSize: "0.656rem", fontWeight: 600, color: SYSTEM_COLORS.GRAY.SOFT_GRAY, letterSpacing: 0.4, margin: "0 0 6px" }}>
          ELASTICIDADE ESTIMADA
        </p>
        <p style={{ fontSize: "0.813rem", fontWeight: 500, color: SYSTEM_COLORS.BLACK.EERIE_BLACK, margin: 0 }}>
          {estimatedElasticityText
            ? estimatedElasticityText
            : `${estimatedElasticity} (cada -5% de preço gera +9% de volume)`}
        </p>
      </hgroup>

      <hgroup style={{
        background: SYSTEM_COLORS.ORANGE.TERRACOTTA_8, border: `1px solid ${SYSTEM_COLORS.RED.BRICK_RED_025}`,
        borderRadius: 10, padding: "12px 14px" }}>
        <p style={{ fontSize: "0.781rem", fontWeight: 600, color: SYSTEM_COLORS.BLACK.EERIE_BLACK,  }}>
          {levelPriceAlertText}
        </p>
      </hgroup>
    </>
  );
};

const QUALITY_STATUS_STYLE = {
  ok: { label: "Ok", color: SYSTEM_COLORS.GREEN.FOREST_GREEN, bg: SYSTEM_COLORS.GREEN.FOREST_GREEN_10 },
  atencao: { label: "Atenção", color: SYSTEM_COLORS.YELLOW.OCHRE, bg: SYSTEM_COLORS.YELLOW.OCHRE_10 },
  critico: { label: "Crítico", color: SYSTEM_COLORS.RED.BRICK_RED, bg: SYSTEM_COLORS.RED.BRICK_RED_10 },
};

const QualityDetail = ({ ctx }) => {
  const { quality } = ctx || {};

  if (!quality || quality.length === 0) return null;

  return (
    <>
      <div style={{ border: `1px solid ${SYSTEM_COLORS.GRAY.CULTURED}`, borderRadius: "10px", overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr style={{ textAlign: "left", background: SYSTEM_COLORS.GRAY.CULTURED }}>
              <th style={{ padding: "10px 12px", fontSize: "0.656rem", fontWeight: 700, color: SYSTEM_COLORS.GRAY.NEUTRAL_GRAY, letterSpacing: 0.4 }}>INDICADOR</th>
              <th style={{ padding: "10px 12px", fontSize: "0.656rem", fontWeight: 700, color: SYSTEM_COLORS.GRAY.NEUTRAL_GRAY, letterSpacing: 0.4, textAlign: "right" }}>VALOR</th>
              <th style={{ padding: "10px 12px", fontSize: "0.656rem", fontWeight: 700, color: SYSTEM_COLORS.GRAY.NEUTRAL_GRAY, letterSpacing: 0.4 }}>REFERÊNCIA</th>
              <th style={{ padding: "10px 12px", fontSize: "0.656rem", fontWeight: 700, color: SYSTEM_COLORS.GRAY.NEUTRAL_GRAY, letterSpacing: 0.4, textAlign: "right" }}>STATUS</th>
            </tr>
          </thead>
          <tbody>
            {quality.map((item) => {
              const statusStyle = QUALITY_STATUS_STYLE[item.status] ?? QUALITY_STATUS_STYLE.ok;

              return (
                <tr key={item.indicatorTypeId} style={{ borderTop: `1px solid ${SYSTEM_COLORS.GRAY.PLATINUM}` }}>
                  <td style={{ padding: "12px", fontWeight: 700, color: SYSTEM_COLORS.BLACK.EERIE_BLACK }}>{item.indicatorTypeName}</td>
                  <td style={{ padding: "12px", fontWeight: 700, color: SYSTEM_COLORS.BLACK.EERIE_BLACK, textAlign: "right" }}>{item.value}</td>
                  <td style={{ padding: "12px", color: SYSTEM_COLORS.GRAY.DIM_GRAY }}>{item.reference}</td>
                  <td style={{ padding: "12px", textAlign: "right" }}>
                    <span style={{
                      display: "inline-flex", alignItems: "center", justifyContent: "center",
                      padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700,
                      color: statusStyle.color, backgroundColor: statusStyle.bg,
                    }}>
                      {statusStyle.label}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

const DETAIL_PANEL_CONFIG = {
  behaviorChange: {
    title: "BESTS DO SUBGRUPO · SEMANA A SEMANA",
    render: (ctx) => <BestsWeeklyTable ctx={{ bestsList: ctx.bests }} />,
    isAvailable: (ctx) => !!ctx.bests?.length,
  },
  // comentar preço do subgrupo em produção
  // levelChange: {
  //   title: "PREÇO DO SUBGRUPO",
  //   render: (ctx) => <LevelPriceDetail ctx={{ levelPrice: ctx.levelPrice }} />,
  //   isAvailable: (ctx) => !!ctx.levelPrice,
  // },
  quality: {
    title: "INDICADORES DE QUALIDADE",
    render: (ctx) => <QualityDetail ctx={{ quality: ctx.quality }} />,
    isAvailable: (ctx) => !!ctx.quality?.length,
  },
};

//const NAV_ORDER = ["behaviorChange", "levelChange", "quality"]; // comentar este em produção
const NAV_ORDER = ["behaviorChange", "quality"];

const DetailNavigator = ({ ctx, actions }) => {
  const { selectedDetail } = ctx || {};
  const { onSelectDetail } = actions || {};

  const currentIndex = NAV_ORDER.indexOf(selectedDetail);
  const activeIndex = currentIndex === -1 ? 0 : currentIndex;

  const goTo = (index) => {
    const wrapped = (index + NAV_ORDER.length) % NAV_ORDER.length;
    onSelectDetail?.(NAV_ORDER[wrapped]);
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6, marginLeft: "auto" }}>
      {NAV_ORDER.map((key, i) => (
        <span
          key={key}
          style={{
            width: i === activeIndex ? 18 : 7,
            height: 7,
            borderRadius: 4,
            background: i === activeIndex ? SYSTEM_COLORS.RED.BRICK_RED : SYSTEM_COLORS.GRAY.GREY,
            transition: "width 0.2s ease, background 0.2s ease",
          }}
        />
      ))}

      <button
        onClick={() => goTo(activeIndex - 1)}
        style={{
          width: 24, height: 24, borderRadius: "50%", border: `1px solid ${SYSTEM_COLORS.GRAY.SILVER}`,
          background: SYSTEM_COLORS.WHITE.WHITE, display: "flex", alignItems: "center", justifyContent: "center",
          cursor: "pointer", marginLeft: 8,
        }}>
        <svg 
          width={12} height={12} viewBox="0 0 24 24" fill="none" stroke={SYSTEM_COLORS.GRAY.GREY}
          strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="m15 18-6-6 6-6" />
        </svg>
      </button>

      <button
        onClick={() => goTo(activeIndex + 1)}
        style={{
          width: 24, height: 24, borderRadius: "50%", border: `1px solid ${SYSTEM_COLORS.GRAY.SILVER}`,
          background: SYSTEM_COLORS.WHITE.WHITE, display: "flex", alignItems: "center", justifyContent: "center",
          cursor: "pointer",
        }}>
        <svg 
          width={12} height={12} viewBox="0 0 24 24" fill="none" stroke={SYSTEM_COLORS.GRAY.GREY}
          strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="m9 18 6-6-6-6" />
        </svg>
      </button>
    </div>
  );
};

export function OpportunityMetricsPanel({ ctx, uiState }) {

  const [isAnalysisModalOpen, setIsAnalysisModalOpen] = useState(false);
  const [selectedDetail, setSelectedDetail] = useState(null);

  const { 
    opportunity, 
    getOpportunityDetails, 
    products,
    opportunityTrendsDetails
  } = ctx || {};

  const { isLoadingTrendsDetails } = uiState || {};

  const { 
    value, 
    startDate, 
    endDate,
    productId,
    type1, 
    trendStatus
  } = opportunity;

  const opportunityDetails = getOpportunityDetails(type1);
  
  const trendDetail = (opportunityTrendsDetails ?? []).filter(
    (trend) => trend.key.split("-")[0] === String(productId)
  );

  const isTrendDetailPending = isLoadingTrendsDetails && trendDetail.length === 0;

  const bests = trendDetail?.map((trend) => trend.bests).filter(Boolean);
  const levelPrice = trendDetail?.levelPrice;
  const quality = [
    ...new Map(
      trendDetail
        ?.map((trend) => trend.quality)
        .filter(Boolean)
        .flat()
        .map((item) => [item.indicatorTypeId, item])
    ).values()
  ];

  const activeDetailConfig = DETAIL_PANEL_CONFIG[selectedDetail];
  const isShowingDetail = activeDetailConfig && activeDetailConfig.isAvailable({ bests, levelPrice, quality });

  const metrics = [
    {
      key: "expectedReturn",
      iconBg: SYSTEM_COLORS.ORANGE.BURNT_ORANGE_12,
      iconColor: SYSTEM_COLORS.ORANGE.BURNT_ORANGE,
      icon: (
        <svg 
          width={18} height={18} viewBox="0 0 24 24" fill="none" stroke={SYSTEM_COLORS.ORANGE.BURNT_ORANGE}
          strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <circle cx="12" cy="12" r="6" />
          <circle cx="12" cy="12" r="2" />
        </svg>
      ),
      label: "RETORNO ESPERADO",
      value: currencyFormatter.format(value),
      valueColor: SYSTEM_COLORS.ORANGE.BURNT_ORANGE,
    },
    {
      key: "period",
      iconBg: SYSTEM_COLORS.WHITE.ALABASTER,
      icon: (
        <svg 
          width={18} height={18} viewBox="0 0 24 24" fill="none" stroke={SYSTEM_COLORS.GRAY.MEDIUM_GRAY}
          strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect width="18" height="18" x="3" y="4" rx="2" />
          <path d="M16 2v4" />
          <path d="M3 10h18" />
          <path d="M8 2v4" />
        </svg>
      ),
      label: "PERÍODO",
      value: generateSubtitlePeriod({ startDate, endDate }),
      valueColor: SYSTEM_COLORS.BLACK.EERIE_BLACK,
    },
    {
      key: "trend",
      iconBg:
        trendStatus === "queda"
          ? SYSTEM_COLORS.RED.BRICK_RED_8
          : SYSTEM_COLORS.GREEN.FOREST_GREEN_8,

      icon:
        trendStatus === "queda" ? (
          <svg
            width={18}
            height={18}
            viewBox="0 0 24 24"
            fill="none"
            stroke={SYSTEM_COLORS.RED.BRICK_RED}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M16 17h6v-6" />
            <path d="m22 17-8.5-8.5-5 5L2 7" />
          </svg>
        ) : (
          <svg
            width={18}
            height={18}
            viewBox="0 0 24 24"
            fill="none"
            stroke={SYSTEM_COLORS.GREEN.FOREST_GREEN}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M16 7h6v6" />
            <path d="m22 7-8.5 8.5-5-5L2 17" />
          </svg>
        ),

      label: "TENDÊNCIA",
      value: textFormatter(trendStatus),
      valueColor: SYSTEM_COLORS.BLACK.EERIE_BLACK,
    },

  ];

  const renderAdvancedAnalysis = useCallback(
    () => (
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <ProductAnalysisChart ctx={{ products: products, productId: productId }} />
      </div>
    ),
    [productId, products]
  ); 

  return (
    <section style={{ border: `1px solid ${SYSTEM_COLORS.GRAY.PLATINUM}`, borderRadius: 16, background: SYSTEM_COLORS.WHITE.WHITE_SMOKE, padding: 20 }}>
      <div style= {{ display: "grid", gridTemplateColumns: "2fr 3fr", gap: "1rem" }}>
        <section style={{ display: "grid", gridAutoRows: "auto auto", gap: "1rem", padding: "0 0 0 1rem" }}>
          
          {/* OPORTUNIDADE */}
          <section style={{ 
            display: "flex", flexDirection: 'column', gap: 14, border: `1px solid ${SYSTEM_COLORS.GRAY.LIGHT_GRAY}`, 
            borderRadius: '1rem', padding: "1rem", backgroundColor: SYSTEM_COLORS.WHITE.WHITE, 
            boxShadow: `0 12px 6px ${SYSTEM_COLORS.BLACK.BLACK_4_PERCENT}`
            }}>
              
            <header style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
              <span style={{ width: 3, height: 14, borderRadius: 2, background: SYSTEM_COLORS.RED.BRICK_RED }} />
              <p style={{ fontSize: "0.813rem", fontWeight: 800, color: SYSTEM_COLORS.BLACK.EERIE_BLACK, letterSpacing: 0.4 }}>
                OPORTUNIDADE DE {opportunityDetails.title?.toUpperCase()}
              </p>
            </header>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "1rem" }}>
              {metrics.map((metric) => (
                <div key={metric.key} style={{ flex: 1, border: `1px solid ${SYSTEM_COLORS.GRAY.PLATINUM}`, borderRadius: 14, padding: 16 }}>
                  <span style={{
                    width: 34, height: 34, borderRadius: 9, background: metric.iconBg,
                    display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 10,
                  }}>
                    {metric.icon}
                  </span>
                  <p style={{ fontSize: "0.656rem", fontWeight: 700, color: SYSTEM_COLORS.GRAY.SOFT_GRAY, letterSpacing: 0.4, margin: "0 0 4px" }}>
                    {metric.label}
                  </p>

                  <p style={{ fontSize: "1rem", fontWeight: 800, color: metric.valueColor, margin: 0 }}>
                    {metric.value}
                  </p>
                </div>
              ))}
            </div>
          </section>
          
          {/* RECOMENDAÇÃO */}
          <section style={{ 
            display: "flex", flexDirection: 'column', gap: 14, border: `1px solid ${SYSTEM_COLORS.GRAY.LIGHT_GRAY}`, 
            borderRadius: '1rem', padding: "1rem", 
            backgroundColor: SYSTEM_COLORS.WHITE.WHITE, boxShadow: `0 12px 8px ${SYSTEM_COLORS.BLACK.BLACK_4_PERCENT}` }}>
            
            {
              renderCardMetrics({ 
                ctx: {
                  startDate: startDate,
                  endDate: endDate,
                  mode: "extense",
                  opportunityType: type1,
                  onSelectDetail: setSelectedDetail,
                  selectedDetail: selectedDetail,
                  bests: bests,
                  levelPrice: levelPrice,
                  quality: quality
                },
                uiState: {
                  isTrendDetailPending: isTrendDetailPending
                }                
              })
            }

            {selectedDetail === "quality" && isShowingDetail && (
              activeDetailConfig.render({ bests, levelPrice, quality })
            )}

            {/* BOTÃO DE ANÁLISE AVANÇADA */}
            <div style={{ display: 'flex', justifyContent: 'center', marginBlockEnd: '0.5rem', inlineSize: "100%" }}>
              <button
                onClick={() => setIsAnalysisModalOpen(true)}
                style={{
                  display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                  background: SYSTEM_COLORS.RED.BRICK_RED, border: "none", borderRadius: 999, padding: "10px 20px",
                  color: SYSTEM_COLORS.WHITE.WHITE, fontSize: 13.5, fontWeight: 700, cursor: "pointer", inlineSize: "100%"
                }}>
                Análise Avançada
                <svg 
                  width={14} height={14} viewBox="0 0 24 24" fill="none" stroke={SYSTEM_COLORS.WHITE.WHITE} 
                  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M7 17 17 7" /><path d="M7 7h10v10" />
                </svg>
              </button>
            </div>            
          </section> 

          <ModalTemplate open={isAnalysisModalOpen} width="650px" closingFunction={() => setIsAnalysisModalOpen(false)} heading=" ">
            {isAnalysisModalOpen && renderAdvancedAnalysis()}
          </ModalTemplate>       
        </section>

        {/* Gráfico */}
        <section style={{ 
          display: 'flex', flexDirection: 'column', justifyContent: 'center',  border: `1px solid ${SYSTEM_COLORS.GRAY.LIGHT_GRAY}`, 
          borderRadius: '1rem', padding: "1rem", backgroundColor: SYSTEM_COLORS.WHITE.WHITE, 
          boxShadow: `0 12px 8px ${SYSTEM_COLORS.BLACK.BLACK_4_PERCENT}`, maxBlockSize: "100%" }}>
          <header style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
            <span style={{ width: 3, height: 14, borderRadius: 2, background: SYSTEM_COLORS.RED.BRICK_RED }} />
            <p style={{ fontSize: "0.813rem", fontWeight: 800, color: SYSTEM_COLORS.BLACK.EERIE_BLACK, letterSpacing: 0.4 }}>
              {(selectedDetail === "behaviorChange" || selectedDetail === "levelChange") && isShowingDetail
                ? activeDetailConfig.title
                : "DEMANDA - PLANO - FORECAST - NOVA TENDÊNCIA"}
            </p>

            <DetailNavigator
              actions={{ onSelectDetail: setSelectedDetail }}
              ctx={{ selectedDetail }}/>
          </header>

          {isShowingDetail && selectedDetail !== "quality" ? (
            activeDetailConfig.render({ bests, levelPrice, quality })
          ) : (
            <Card style={{ height: "100%", borderRadius: "1rem" }}>
              <PredictionChart 
                ctx={{ productId: productId }} 
                uiState={{
                  location: LOCATION_VALUES_FOR_PREDICTION_CHART.OPPORTUNITY_ACCORDION
                }}
              />
            </Card>
          )}
        </section>
      </div>
    </section>
  );
};